export const CLEAR_LABEL_BATCH_STATUS_MODAL_BATCHES = 'CLEAR_LABEL_BATCH_STATUS_MODAL_BATCHES';
export const clearLabelBatchStatusModalBatches = () => ({
  type: CLEAR_LABEL_BATCH_STATUS_MODAL_BATCHES,
});

export const ADD_LABEL_BATCH_STATUS_MODAL_BATCH = 'ADD_LABEL_BATCH_STATUS_MODAL_BATCH';
export const addLabelBatchStatusModalBatch = (batch) => ({
  type: ADD_LABEL_BATCH_STATUS_MODAL_BATCH,
  batch,
});

export const LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_REQUEST = 'LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_REQUEST';
export const labelBatchStatusModalGetWarningAndErrorRequest = (batchId) => ({
  type: LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_REQUEST,
  batchId,
});

export const LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_SUCCESS = 'LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_SUCCESS';
export const labelBatchStatusModalGetWarningAndErrorSuccess = (response) => ({
  type: LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_SUCCESS,
  response,
});

export const LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_FAILURE = 'LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_FAILURE';
export const labelBatchStatusModalGetWarningAndErrorFailure = (error) => ({
  type: LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_FAILURE,
  error,
});

export const ON_RETRY_BATCH_IN_LABEL_BATCH_STATUS_MODAL_REQUEST = 'ON_RETRY_BATCH_IN_LABEL_BATCH_STATUS_MODAL_REQUEST';
export const retryBatch = (batchId) => ({
  type: ON_RETRY_BATCH_IN_LABEL_BATCH_STATUS_MODAL_REQUEST,
  batchId,
});

export const LABEL_BATCH_STATUS_MODAL_ARCHIVE_BATCHES_SUCCESS = 'LABEL_BATCH_STATUS_MODAL_ARCHIVE_BATCHES_SUCCESS';
export const labelBatchStatusModalArchiveBatchesSuccess = (batchIds) => ({
  type: LABEL_BATCH_STATUS_MODAL_ARCHIVE_BATCHES_SUCCESS,
  batchIds,
});
